<template>
  <TolModal
    :title="$t('projects.details.labels.createEventType')"
    :submit-button-text="$t('projects.details.labels.save')"
    @close="clearFormAndClose()"
    @submit="save()"
  >
    <template v-slot:body>
      <form>
        <div class="form-group">
          <div class="form-control">
            <label>
              {{ $t('projects.eventTypes.labels.eventTypeName') }}
              <span class="asterisk">*</span>
            </label>
            <InputField
              v-model="eventType.name"
              type="text"
              class="bordered"
              :class="{ error: formErrors['name'] }"
              picker="minus-circle"
              @input="eventType.name = $event"
              @picker-click="eventType.name = ''"
            />
          </div>
          <div class="form-control">
            <label>
              {{ $t('projects.eventTypes.labels.scope') }}
              <span class="asterisk">*</span>
            </label>
            <InputField
              v-model="eventType.scope_of_work"
              type="text"
              class="bordered"
              :class="{ error: formErrors['scopeOfWork'] }"
              picker="minus-circle"
              @input="eventType.scope_of_work = $event"
              @picker-click="eventType.scope_of_work = ''"
            />
          </div>
          <div class="form-row">
            <div class="form-control">
              <label>
                {{ $t('projects.eventTypes.labels.isOnsiteDocumentationRequired') }}
              </label>
              <Checkbox
                size="tiny"
                :checked="eventType.is_onsite_documentation_required"
                @change="
                  eventType.is_onsite_documentation_required = !eventType.is_onsite_documentation_required
                "
              />
            </div>
            <div class="form-control">
              <label>
                {{ $t('projects.eventTypes.labels.isTMinus1CallRequired') }}
              </label>
              <Checkbox
                size="tiny"
                :checked="eventType.is_t_minus_1_call_required"
                @change="
                  eventType.is_t_minus_1_call_required = !eventType.is_t_minus_1_call_required
                "
              />
            </div>
          </div>
          <div class="form-control">
            <label>
              {{ $t('projects.eventTypes.labels.status') }}
              <span class="asterisk">*</span>
            </label>
            <dropdown-select
              :menu-items="statuses"
              :selected-item="eventType.status"
              class="bordered"
              @select-item="eventType.status = $event"
            >
            </dropdown-select>
          </div>
        </div>
      </form>
    </template>
  </TolModal>
</template>

<script>
import Checkbox from '@/app/components/Checkbox';
import DropdownSelect from '@/app/components/DropdownSelect';
import InputField from '@/app/components/InputField';
import TolModal from '@/app/components/TolModal';

export default {
  name: 'CreateEventTypeModal',
  components: {
    Checkbox,
    DropdownSelect,
    InputField,
    TolModal
  },
  data() {
    return {
      eventType: {
        name: '',
        scope_of_work: '',
        status: null,
        is_onsite_documentation_required: false,
        is_t_minus_1_call_required: false
      },
      statuses: ['ACTIVE', 'INACTIVE', 'COMPLETED']
    };
  },
  computed: {
    formErrors() {
      return this.$store.getters.EventTypeValidationErrors;
    }
  },
  methods: {
    clearFormAndClose() {
      this.eventType = {
        name: '',
        scope_of_work: '',
        status: null,
        is_onsite_documentation_required: false,
        is_t_minus_1_call_required: false
      };
      this.$emit('close', this.eventType);
    },
    async save() {
      this.$emit('save', this.eventType);
    }
  }
};
</script>

<style scoped lang="scss">
.form-group > div {
  margin-bottom: 1rem;
}

.form-row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media only screen and (min-width: 600px) {
    flex-direction: row;
  }
}

@media only screen and (max-width: 599px) {
  .form-row > div {
    margin-bottom: 1rem;
  }
}

.asterisk {
  color: red;
}
</style>
